import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const EditorModalSwitches = ({ switchStates, changeSwitch }) => {
  const { t } = useTranslation()

  return (
    <>
      <Row className='mb-3'>
        <Form.Group as={Col}>
          <Form.Check
            type='switch'
            id='isVisibleNews'
            label={t('modal:msgVisible')}
            checked={switchStates.isVisibleNews || false}
            onChange={changeSwitch}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Check
            type='switch'
            id='isCollapsed'
            label={t('modal:msgCollapsed')}
            checked={switchStates.isCollapsed || false}
            onChange={changeSwitch}
          />
        </Form.Group>
      </Row>
      <Row className='mb-3'>
        <Form.Group as={Col}>
          <Form.Check
            type='switch'
            id='creationDate_IsVisible'
            label={t('modal:dateVisible')}
            checked={switchStates.creationDate_IsVisible || false}
            onChange={changeSwitch}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Check
            type='switch'
            id='creatorName_IsVisible'
            label={t('modal:msgCreatorVisible')}
            checked={switchStates.creatorName_IsVisible || false}
            onChange={changeSwitch}
          />
        </Form.Group>
      </Row>
    </>
  )
}

export default EditorModalSwitches
